import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { SessionService } from '../services/session.service';
import { AuthService } from 'src/app/features/auth/services/auth.service';


@Injectable()
export class RefreshInterceptor implements HttpInterceptor {

  constructor(
    private sessionService: SessionService,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(

      catchError((error: HttpErrorResponse) => {

        // 👉 Only handle 401
        if (error.status === 401) {

          const session = this.sessionService.getSession();

          if (!session?.refreshToken) {
            this.sessionService.clearSession();
            return throwError(() => error);
          }

          // 🔥 Call refresh endpoint
          return this.authService.refresh(session.refreshToken).pipe(

   switchMap((res: any) => {

  const session = this.sessionService.getSession();

  this.sessionService.setSession({
    ...session!,                      // keeps userId, email, fullName, companyId, role
    accessToken: res.accessToken,     // overwrites only the tokens
    refreshToken: res.refreshToken
  });

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${res.accessToken}`
    }
  });

  return next.handle(cloned);
})
          );
        }

        return throwError(() => error);
      })
    );
  }
}